import { Button, Card, Popconfirm, Row, Space, Tooltip } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  CardComponent,
  CardTitle,
  ColumnComponent,
} from "../../../components/ui";
import Table from "antd/es/table";
import DataContext from "../../../context/DataContext";
import { useParams } from "react-router-dom";
import { INVOICES_WARNING } from "../../../utils/data";
import { transactionColumns } from "../../../utils/colums/transactionColumns";
import AuthContext from "../../../context/AuthContext";
import { useDemoModal } from "../../../hooks";
import { exportTransactionList } from "../../../utils/func/ExportFile";
import { SearchInput } from "../../../components/functional";
import QuickbooksContext from "../../../context/QuickbooksContext";
import { TablePaginationConfig } from "antd/lib";
import { FilterValue } from "antd/es/table/interface";
import { DownloadOutlined, DeleteOutlined } from "@ant-design/icons";

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}

export const JournalEntryClient = () => {
  const { idClient } = useParams();
  const { isDemoEnv, role } = useContext(AuthContext);
  const { DemoModal, openModalDemo } = useDemoModal();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const { onChangeSearchQuery } = useContext(QuickbooksContext);
  const [tableParams, setTableParams] = useState<TableParams>({});
  const hasBeenWarned = useRef(false);
  const {
    getData,
    invoiceList,
    handleBulkDeleteData,
    dataLoading,
    handleWarning,
    dataWarning,
  } = useContext(DataContext);

  useEffect(() => {
    setTableParams({
      pagination: {
        pageSize: 100,
        total: invoiceList.length,
        onChange: (_, pageSize) => {
          setTableParams((prev) => {
            return {
              ...prev,
              pagination: {
                ...prev.pagination,
                pageSize: pageSize,
              },
            };
          });
        },
      },
    });
  }, [invoiceList]);

  useEffect(() => {
    if (idClient) {
      getData("journal", idClient);
    }
  }, [idClient]);

  useEffect(() => {
    onChangeSearchQuery("");
    if (
      !dataWarning.status &&
      !hasBeenWarned.current &&
      role !== "DEMO" &&
      role !== "CLIENT" &&
      role
    ) {
      handleWarning(
        true,
        INVOICES_WARNING,
        undefined,
        () => (hasBeenWarned.current = true),
      );
      hasBeenWarned.current = true;
    }
  }, [role]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  return (
    <div className="general-view">
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <CardTitle title="Journal Entries" />
        </ColumnComponent>
        <ColumnComponent>
          <Card
            className="summary-client__card"
            styles={{ body: { display: "none" } }}
            actions={[
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Actions</label>
                <Space direction="horizontal" size={0}>
                  <Tooltip title="Export Journal Entries" placement="bottom">
                    <Button
                      type="link"
                      icon={<DownloadOutlined />}
                      onClick={() =>
                        exportTransactionList(
                          invoiceList,
                          "Journal Entry",
                          selectedRowKeys as string[],
                        )
                      }
                    ></Button>
                  </Tooltip>
                  <>
                    {role !== "CLIENT" && role !== "DEMO" ? (
                      <>
                        <Popconfirm
                          title="Sure to delete?"
                          onConfirm={() => {
                            if (isDemoEnv) {
                              openModalDemo();
                            } else {
                              if (idClient) {
                                handleBulkDeleteData(
                                  "journal",
                                  idClient,
                                  selectedRowKeys as string[],
                                );
                                setSelectedRowKeys([]);
                              }
                            }
                          }}
                        >
                          <Tooltip
                            title="Delete Selected Journal Entries"
                            placement="bottom"
                          >
                            <Button
                              type="link"
                              disabled={!hasSelected}
                              icon={<DeleteOutlined />}
                            ></Button>
                          </Tooltip>
                        </Popconfirm>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                </Space>
              </Space>,
              <span style={{ marginLeft: 8, marginRight: 8 }}>
                {hasSelected
                  ? `${selectedRowKeys.length} items selected  of ${invoiceList.length}`
                  : ""}
              </span>,
              <Space direction="vertical" size={0} style={{ width: "80%" }}>
                <label>Search</label>
                <SearchInput
                  onSearch={(value: string) => {
                    if (value) {
                      idClient && getData("journal", idClient, value);
                    } else {
                      idClient && getData("journal", idClient);
                    }
                  }}
                />
              </Space>,
            ]}
          ></Card>
        </ColumnComponent>
        <ColumnComponent>
          <Table
            bordered
            loading={dataLoading}
            columns={transactionColumns({
              role,
              action: (record) => {
                if (isDemoEnv) {
                  openModalDemo();
                } else {
                  record.DocNumber &&
                    idClient &&
                    handleBulkDeleteData("journal", idClient, [
                      record.DocNumber,
                    ]);
                }
              },
            })}
            dataSource={invoiceList}
            size="small"
            rowKey={"Id"}
            pagination={tableParams.pagination}
            rowSelection={rowSelection}
          />
        </ColumnComponent>
      </Row>
      <DemoModal />
    </div>
  );
};
